import React, { useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import Header from "../components/header";
import Footer from "../components/footer";
import { useAuth } from "./context/authcontext";
import { API_URLS } from "../api/apiConfig";
import { getWithAuth } from "../api/api";
import Cookies from "universal-cookie";
import { decryptData, decryptSession } from "../authentication/sessionCrypto";

const MainLayout = () => {
  const { authData, setAuthData } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();

  const KEY_B64 = process.env.REACT_APP_SESSION_AES_KEY_B64;

  useEffect(() => {
    const checkUserToken = async () => {
      try {
        const cookies = new Cookies();
        const session_token_cookie = cookies.get("session_token"); // tu access token para llamar a la API
        if (!session_token_cookie) {
          navigate("/login");
          return;
        }

        setIsLoading(true);

        // 1) pides el token CIFRADO al backend
        const rsp = await getWithAuth(API_URLS.GET_USER_SESSION);
        const { iv, session_token } = rsp.data;

        // 2) lo DESCIFRAS en el navegador
        const userData = await decryptData(session_token, iv, KEY_B64);

        console.log("User Data:", userData);

        setAuthData({
          isAuthenticated: true,
          session_token: session_token_cookie,
          user_data: userData,
        });
      } catch (err) {
        console.error("Error verificando sesión:", err);
        navigate("/login");
      } finally {
        setIsLoading(false);
      }
    };

    checkUserToken();
  }, []);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div className="d-flex flex-column flex-root app-root" id="kt_app_root">
      <div className="app-page flex-column flex-column-fluid" id="kt_app_page">
        {!isLoading && authData.user_data && (
          <>
            <Header toggleDrawer={toggleDrawer} userData={authData.user_data} />
            <div
              className="app-wrapper flex-column flex-row-fluid"
              id="kt_app_wrapper"
            >
              <Sidebar
                isDrawerOpen={isDrawerOpen}
                setIsDrawerOpen={setIsDrawerOpen}
              />
              <div
                className="app-main flex-column flex-row-fluid"
                id="kt_app_main"
              >
                <Outlet />
                <Footer />
              </div>
            </div>
          </>
        )}
        {isLoading && (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div
              className="spinner-grow text-color-amarillo-livensa"
              style={{ width: "5rem", height: "5em" }}
              role="status"
            ></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainLayout;
